module.exports = __webpack_public_path__ + "static/img/0507ny_tit02.1f8e252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/0507ny_tit02.jpg
// module id = WDRT
// module chunks = 0